import { cookieDocument, legalCompanyDetails } from "@mealmanager/legal-content";
import type { Route } from "./+types/page";
import { buildSeoMeta } from "../utils/seo";
import LegalDocumentPage from "../components/LegalDocumentPage";

export const meta: Route.MetaFunction = ({ location }) =>
  buildSeoMeta({
    location,
    title: `${cookieDocument.title} | ${legalCompanyDetails.brandName}`,
    description: `Read ${legalCompanyDetails.brandName}'s cookie policy, including how cookies are used on the public site and apps.`,
    type: "article",
    modifiedTime: cookieDocument.effectiveDate,
  });

export default function CookiePolicyPage() {
  return <LegalDocumentPage document={cookieDocument} />;
}
